import { render, staticRenderFns } from "./FormCreateTransfer.vue?vue&type=template&id=76bf3812&lang=pug"
import script from "./FormCreateTransfer.vue?vue&type=script&lang=js"
export * from "./FormCreateTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports